import { useEffect, useState } from "react";
import dayjs from "dayjs";
import Modal from "react-modal";
import { ConfirmModalStyles } from "lib/constants";
import { showToast } from "ui/components/common";
import { Button } from "antd";
import { useWSService } from "ui/nvrs/service";
export default function TomlDownloader({
  deviceItem,
  orgId,
}: {
  deviceItem: any;
  orgId: string;
}) {
  const [modalShow, setModalShow] = useState(false);
  const [speedTestloading, setSpeedTestLoading] = useState(false);
  const { testSpeed } = useWSService();
  const [testResult, setTestResult] = useState<any>(null);
  async function onSpeedTest() {
    setSpeedTestLoading(true);
    try {
      const res: any = await testSpeed(
        orgId,
        deviceItem.edgeId || deviceItem.deviceId,
      );
      setTestResult(res.deviceSpeedTestReplyRes);
    } catch (e) {
      if (e.message.indexOf("4020") !== -1) {
        showToast(1, "A test is already in progress");
      } else {
        showToast(1, "Speed Test Failed. Error:" + e);
      }
    } finally {
      setSpeedTestLoading(false);
    }
  }
  function renderSpeed(speed) {
    return <>{speed ? speed / 1000 + "Mbps" : "Not Tested Yet"}</>;
  }
  function renderTime(time) {
    return (
      <>
        {time
          ? "Updated on " + dayjs(Number(time)).format("YYYY-MM-DD HH:mm:ss")
          : ""}
      </>
    );
  }
  return (
    <>
      <Modal
        isOpen={modalShow}
        style={ConfirmModalStyles}
        contentLabel="Example Modal"
      >
        <h1 className="text-xl font-bold">Test Bandwidth</h1>
        <div className="bg-zinc-50 p-3 mt-3 rounded-lg mb-3">
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "130px" }}>
              <div style={{ color: "#222222", textWrap: "nowrap" }}>
                Network Bandwidth
              </div>
              <div style={{ marginTop: "8px" }}>
                {renderSpeed(
                  testResult?.testBandwidth || deviceItem?.testBandwidth,
                )}
              </div>
              <div
                style={{
                  color: "#222222",
                  marginTop: "16px",
                  textWrap: "nowrap",
                }}
              >
                Current Speed Limit
              </div>
              <div style={{ marginTop: "8px" }}>
                {renderSpeed(
                  testResult?.bandwidthLimit || deviceItem?.bandwidthLimit,
                )}
              </div>
            </div>
            <Button
              className="primaryButton"
              loading={speedTestloading}
              onClick={onSpeedTest}
            >
              Test
            </Button>
          </div>
          <div style={{ width: "100%", marginTop: "12px" }}>
            <span style={{ color: "#222222" }}>
              {renderTime(testResult?.lastTestedAt || deviceItem?.lastTestedAt)}
            </span>
          </div>
        </div>
        <div className="float-right mt-6">
          <button
            className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setSpeedTestLoading(false);
              setModalShow(false);
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>
      {deviceItem.status !== "offline" && (
        <Button onClick={() => setModalShow(true)} type="link">
          Test BandWidth
        </Button>
      )}
    </>
  );
}
